/** globals grecaptcha */
/**
 * 
 * @param {string} action being performed
 * @returns string
 */
export async function useRecaptcha(action = 'charge') {
  return new Promise((resolve, reject) => {
    try {
      grecaptcha.ready(function() {
        grecaptcha.execute(window.PM3.GRCSK, { action })
          .then(resolve)
          .catch(reject);
      });
    } catch (err) {
      reject(err);
    }
  });
}
